import type { QueryFunction } from 'common/queryFunction';
import { useQuery } from 'react-query';

import { getAccountsKey, useRequest } from '@frontend/api';

export const getFacilitiesQueryKey = () =>
  [...getAccountsKey(), 'facilities'] as const;

export const getFacilityDetailsQueryKey = (params: unknown) =>
  [...getFacilitiesQueryKey(), 'details', params] as const;

export type UseFacilityParams = {
  facilityId: string;
};

export type FacilityData = unknown;

export const useFacility: QueryFunction<
  FacilityData,
  [UseFacilityParams],
  ReturnType<typeof getFacilityDetailsQueryKey>
> = (params, { requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getFacilityDetailsQueryKey(params);
  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/accounts/facilities/${params.facilityId}`, {
        init: {
          signal,
        },
      }),
  });
};
